import React, { useMemo, useState } from "react";
import styles from "./Reports.module.css";
import { useReports } from "../../hooks/useReports";
import {
  TableComponent,
  ActionsContainer,
  Modal,
} from "@react-solutions-ui/findmore-ui";
import ReportIcon from "../../../../assets/icons/reportIcon.svg";
import { IEvaluationDetail } from "../../Interfaces/IReportsInterface";
import type { TableProps } from "antd";
import Loader from "../../../../components/ui/Loader";
import { useNavigate } from "react-router-dom";

export default function Reports() {
  const { data, loading, error } = useReports();
  const employee = data?.employeeDetails ?? null;
  const navigate = useNavigate();
  const [selectedYear] = useState<string>("Todos");

  const filteredReports = useMemo(() => {
    const allReports = data?.evaluationDetails ?? [];

    if (selectedYear === "Todos") return allReports;
    return allReports.filter((rep) => rep.year === Number(selectedYear));
  }, [data?.evaluationDetails, selectedYear]);

  const reportColumns: TableProps<IEvaluationDetail>["columns"] = [
    {
      title: "Ano",
      dataIndex: "year",
      key: "year",
      onCell: () => ({ "data-label": "Ano" } as any),
      render: (text: any, record: IEvaluationDetail) => (
        <div className={styles.rowWithActions}>
          <span className={styles.authorText}>{text}</span>
          <ActionsContainer mobile={true}>
            <a href={`/report/${record.id}`}>
              <img
                src={ReportIcon}
                alt="ver"
                className={styles.mobileActionIcon}
              />
            </a>
          </ActionsContainer>
        </div>
      ),
    },
    {
      title: "Nota final",
      dataIndex: "finalEvaluation",
      key: "finalEvaluation",
      onCell: () => ({ "data-label": "Nota final" } as any),
      render: (value: string | undefined) => value?.trim() || "-",
    },
    {
      title: "Data de submissão",
      dataIndex: "submitDate",
      key: "submitDate",
      onCell: () => ({ "data-label": "Data de submissão" } as any),
      render: (value: string | undefined, row: IEvaluationDetail) =>
        row.statusReasonType === "Completed" && value
          ? new Date(value).toLocaleDateString("pt-PT")
          : "-",
    },
    {
      title: "Estado",
      dataIndex: "statusReasonType",
      key: "statusReasonType",
      onCell: () => ({ "data-label": "Estado" } as any),
      render: (_: any, row: IEvaluationDetail) => {
        let value = row.statusReasonType;
        console.log(row);
        let className = "";

        switch (value) {
          case "Not Started":
            className = styles.statusNotStarted;
            break;
          case "In Progress":
            if (row.evaluatorStatus === 122470002) {
              value = "In Evaluation";
              className = styles.statusInEvaluation;
            } else if (row.evaluatorStatus === 122470001) {
              value = "Evaluated";
              className = styles.statusEvaluated;
            } else {
              className = styles.statusInProgress;
            }
            break;
          case "Completed":
            className = styles.statusCompleted;
            break;
          default:
            value = "Not Started";
            className = styles.statusNotStarted;
        }

        const labelMap: Record<string, string> = {
          "Not Started": "POR INICIAR",
          "In Progress": "POR AVALIAR",
          Completed: "CONCLUÍDO",
          "In Evaluation": "EM AVALIAÇÃO",
          Evaluated: "AVALIADO",
        };

        return (
          <span className={`${styles.statusBadge} ${className}`}>
            {labelMap[value]}
          </span>
        );
      },
    },
    {
      title: "Ações",
      key: "actions",
      className: "hide-on-mobile",
      onCell: () => ({ "data-label": "Ações" } as any),
      render: (_: any, record: IEvaluationDetail) => (
        <ActionsContainer>
          <button
            className={styles.evaluateButton}
            disabled={
              record.statusReasonType === "Not Started" ||
              (record.statusReasonType === "In Progress" &&
                record.evaluatorStatus === 122470001)
            }
            onClick={() => {
              if (
                record.evaluatorStatus === 1 &&
                record.statusReasonType === "In Progress"
              ) {
                navigate(`/questionnaire?id=${record.evaluatorId}`);
              } else {
                navigate(`/report/${record.id}`);
              }
            }}
          >
            {record.evaluatorStatus === 1 &&
            record.statusReasonType === "In Progress"
              ? "Iniciar Autovaliação"
              : "Ver relatório"}
          </button>
        </ActionsContainer>
      ),
    },
  ];

  if (loading) return <Loader text="A carregar relatórios..." />;
  if (error || !data || !employee) return <div className={styles.error}></div>;

  return (
    <>
      <div className={styles.blueProfile}>
        <div className="page-container">
          <div className={styles.userInfo}>
            <div className={styles.avatarCircle}>
              {data.photo ? (
                <img
                  src={`data:image/jpeg;base64,${atob(data.photo)}`}
                  alt="Avatar"
                />
              ) : (
                employee.name
                  .split(" ")
                  .map((p) => p[0])
                  .join("")
                  .toUpperCase()
              )}
            </div>
            <div className={styles.userText}>
              <h2 className={styles.userName}>{employee.name}</h2>
              <p className={styles.areaEmployee}>{employee.areaName}</p>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.reportContainer} page-container`}>
        <div className={styles.reportBox}>
          <div className={styles.textReportBox}>
            <div className={styles.textBox}>
              <span className={styles.titleReport}>RELATÓRIOS</span>
              <span className={styles.smallText}>
                Consulta os teus relatórios
              </span>
            </div>
          </div>

          <TableComponent
            columns={reportColumns}
            data={filteredReports}
            pageSize={9}
            loading={loading}
          />
        </div>
      </div>
    </>
  );
}
